import type { ReactNode } from 'react';
import type { BoxProps } from '@material-ui/core';
import { Box } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

interface InfoBoxProps extends BoxProps {
  children: ReactNode;
}

/** A styled Box element includes an info icon */
export const InfoBox = (props: InfoBoxProps) => {
  const { children, ...restProps } = props;
  return (
    <Box fontWeight="fontWeightMedium" borderRadius={8} p={2} bgcolor="grey.500" display="flex" {...restProps}>
      <InfoOutlinedIcon htmlColor="#6b7a86" />
      <Box
        ml={1}
        color="grey.200"
        fontWeight={400}
        letterSpacing="-0.187px"
        lineHeight={1.3}
        display="flex"
        alignItems="center"
      >
        <div>{children}</div>
      </Box>
    </Box>
  );
};
